import { getCookie } from './cookies';

export const formatMarketingAttributionValueFromCookie = () => {
  const cookieString = getCookie('__lmi_ma');
  if (!cookieString) return {};
  const cookieStringArray = cookieString.split('|');
  const cookieObject: {
    [utmParam: string]: string;
  } = {};
  cookieStringArray.forEach((index) => {
    const keyValuePair = index.split('=');
    cookieObject[keyValuePair[0]] = keyValuePair[1];
  });

  return {
    userreferrer: cookieObject.userreferrer || '',
    campaignsource: cookieObject.campaignsource || '',
    utmmedium: cookieObject.utmmedium || '',
    utmcampaign: cookieObject.utmcampaign || '',
    utmsource: cookieObject.utmsource || '',
    utmterm: cookieObject.utmterm || '',
    utmcontent: cookieObject.utmcontent || '',
  };
};

export const formatMarketingAttributionValueFromCookieForAMP = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    referrer: document.referrer || '',
    fullUrl: window.location.href || '',
    utmMedium: urlParams.get('utm_medium') || '',
    utmCampaign: urlParams.get('utm_campaign') || '',
    utmSource: urlParams.get('utm_source') || '',
  };
};
